__turbopack_context__.v({
  "arrowIcon": "x_KH4W_arrowIcon",
  "searchResultItem": "x_KH4W_searchResultItem",
  "subtitle": "x_KH4W_subtitle",
  "title": "x_KH4W_title",
});
